import { Color } from '../common/index.ts';
import { Spinner } from './Spinner.tsx';

export const ButtonSpinner: React.FC<{color?: Color}>= ({ color = 'primary' }) => (
    <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -40%)'}} data-id="button-spinner">
        <Spinner size="small" color={color} />
    </div>
);
